import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";

// 🔄 Spinner Animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// 🌀 Loader Styles
const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
`;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [shouldScroll, setShouldScroll] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleClick = (event) => {
      let target = event.target;

      // ✅ Check if the clicked element is a <Link> (React Router)
      while (target && target.tagName !== "A") {
        target = target.parentElement;
      }

      if (target && target.hasAttribute("href")) {
        setShouldScroll(true); // ✅ Enable scrolling only for Link clicks
        setLoading(true); // ✅ Show loader
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    if (shouldScroll) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
        setShouldScroll(false); // ✅ Reset scroll state

        // ✅ Hide loader after 500ms (adjust if needed)
        setTimeout(() => setLoading(false), 300);
      });
    }
  }, [pathname, shouldScroll]);
  

  return loading ? (
    <Loader>
      <Spinner />
    </Loader>
  ) : null;
};

export default ScrollToTop;
